module.exports = __webpack_public_path__ + "img/bg-1.393cf61a.jpg";